/**
 * Groups API - Fix Feeds
 *
 * POST /v1/schools/:schoolId/groups/:groupId/fix-feeds
 * Re-syncs a group's Stream feed follows against its member list.
 */

import { z } from 'zod'

export const FixGroupFeedsResponseSchema = z.object({
  message: z.string(),
  data: z.object({
    groupId: z.string(),
    totalMembers: z.number(),
    successfulSyncs: z.number(),
    failedSyncs: z.number(),
    skippedMembers: z.number(),
    followsAdded: z.number(),
    staleFollowsRemoved: z.number(),
    errors: z.array(z.object({ memberPublicId: z.string(), error: z.string() }))
  })
})

export type FixGroupFeedsResponse = z.infer<typeof FixGroupFeedsResponseSchema>
